// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"598":"abf22276","718":"b033cbc6","960":"54223ea1"}[chunkId] + ".js";
};